// components/skeleton/FooterSkeleton.tsx
"use client";

export default function FooterSkeleton() {
  return (
    <div className="pt-5 pb-2 placeholder-glow">
      <footer className="px-3 pt-5">
        <div className="container">
          <div className="row g-4">

            {/* Brand Section Skeleton */}
            <div className="col-12 col-md-3">
              <div className="placeholder col-8 mb-3" style={{ height: 40 }}></div>
              <div className="placeholder col-12 mb-2"></div>
              <div className="placeholder col-10 mb-4"></div>

              {/* Social icons skeleton */}
              <div className="d-flex gap-2">
                {Array.from({ length: 4 }).map((_, i) => (
                  <div
                    key={i}
                    className="placeholder rounded-circle"
                    style={{ width: 32, height: 32 }}
                  ></div>
                ))}
              </div>
            </div>

            {/* Footer Links Skeleton (3 columns) */}
            {Array.from({ length: 3 }).map((_, col) => (
              <div className="col-6 col-md-2" key={col}>
                <div className="placeholder col-8 mb-3"></div>

                <ul className="list-unstyled d-flex flex-column gap-2">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <li key={i}>
                      <div className="placeholder col-10"></div>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            {/* Newsletter Skeleton */}
            <div className="col-12 col-md-3">
              <div className="placeholder col-10 mb-3"></div>

              <div className="placeholder col-12 mb-2" style={{ height: 42 }}></div>
              <div className="placeholder col-12 mb-2" style={{ height: 42 }}></div>

              <div
                className="placeholder col-12 rounded-pill"
                style={{ height: 42 }}
              ></div>
            </div>

          </div>
        </div>
      </footer>

      {/* Copyright */}
      <div className="container py-5 text-center">
        <div className="placeholder col-6 mx-auto"></div>
      </div>
    </div>
  );
}
